import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';

import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { SiteSelectItemDto } from '@app/api/marketplace/models';
import { ProductVariantComponent } from '@products/components/forms/product-variant/product-variant.component';
import {
  ProductCollectionsActions,
  ProductCollectionsSelectors,
} from '@products/components/product-collections/store/product-collections.slice';
import {
  CollectionSubtype,
  collectionSubtypes,
} from '@shared/enums/packaging-subtype';
import { logInvalidControls } from '@shared/helpers/form-helper';
import { formValueEmptyFields } from '@shared/helpers/form-value-empty-fields.helper';
import { trimInput } from '@shared/helpers/input-trim-helper';
@Component({
  selector: 'app-product-collection-level',
  templateUrl: './product-collection-level.component.html',
  styleUrls: ['./product-collection-level.component.scss'],
})
export class ProductCollectionLevelComponent implements OnChanges, OnDestroy {
  @Input() form!: UntypedFormGroup;
  @Input() readOnly = false;
  @Input() groupIndex!: number;
  @Input() parentPackagingUnitId!: string;
  @Input() last = false;
  @Input() showLevelButtons = true;
  @Output() delete = new EventEmitter();
  @Output() edit = new EventEmitter();
  @Output() cancelEditing = new EventEmitter<boolean>();

  TITLE = 'PRODUCTS.COLLECTION_UNIT.';

  subtypes: CollectionSubtype[] = [...collectionSubtypes];
  packagingUnits$!: Observable<SiteSelectItemDto[] | undefined>;

  subs = new Subscription();

  originalValue: any;

  constructor(private store: Store, private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form'] && this.form && this.form.value.packingMethodSubType) {
      this.originalValue = this.form.value;
      if (this.form.value.packingMethodSubType) {
        this.onSubtypeChange(
          {
            value: this.form.value.packingMethodSubType,
          } as MatSelectChange,
          true
        );
      }
    }
  }

  changeDepositFee() {
    if (
      this.originalValue?.withDepositFee !==
      this.form.controls['withDepositFee']?.value
    ) {
      this.form.controls['packingMethodSubType']?.reset();
      this.form.controls['refId'].reset();
      if (this.form.value.withDepositFee) {
        this.form.controls['refId'].setValidators(Validators.required);
      } else {
        this.form.controls['refId'].clearValidators();
      }
      this.form.updateValueAndValidity();
    }
  }

  onSubtypeChange(event: MatSelectChange, init = false) {
    this.packagingUnits$ = this.store.select(
      ProductCollectionsSelectors.selectPackagingUnitsBySubtype(
        this.form.value.withDepositFee,
        event?.value
      )
    );
    if (!init) {
      this.form.controls['refId'].patchValue('');
      this.subs.add(
        this.packagingUnits$.subscribe((packagingUnits) => {
          if (!packagingUnits) {
            this.store.dispatch(
              ProductCollectionsActions.loadPackagingUnitsBySubtype.trigger({
                withDepositFee: this.form.value.withDepositFee,
                packingMethodSubType: event?.value,
              })
            );
          }
        })
      );
    }
  }

  onUniqueChange(event: boolean) {
    if (event) {
      this.form.addControl(
        'productVariationData',
        ProductVariantComponent.buildForm(this.fb)
      );
    } else {
      this.form.removeControl('productVariationData');
    }
  }

  onDelete() {
    this.delete.emit();
  }

  cancel() {
    if (this.originalValue) {
      this.form.reset(this.originalValue);
      this.form.disable();
    }
    this.cancelEditing.emit(!this.form.value.id);
  }

  onEdit() {
    this.originalValue = this.form.value;
    this.edit.emit();
    this.form.enable();
  }

  onSubmit() {
    if (this.form.valid) {
      // A retailersAllowed, és a retailersAllowedModifiable nem küldhető ki a BE-nek, de nekünk szükséges a kiskerek egységes toggle-ezéséhez
      (
        this.form.get(
          'productVariationData.customerSegment'
        ) as UntypedFormGroup
      )?.removeControl('retailersAllowed');
      (
        this.form.get(
          'productVariationData.customerSegment'
        ) as UntypedFormGroup
      )?.removeControl('retailersAllowedModifiable');

      const formValue = formValueEmptyFields(trimInput(this.form.value));

      this.store.dispatch(
        ProductCollectionsActions.saveCollection.trigger({
          collectionGroupIndex: this.groupIndex,
          packagingUnitId: this.parentPackagingUnitId,
          collectionPackagingUnitId: formValue.id,
          collectionLevel: formValue,
          scrollTop: formValue.unique
            ? Math.max(window.scrollY - 1000, 0)
            : window.scrollY,
        })
      );
    } else {
      logInvalidControls(this.form);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
